import { SOCKET_EVENTS } from '@forever/shared';
import { qk, useInvalidate } from '@/lib/queries';
import { useSocketEvent } from '@/lib/socket';

/**
 * Sunucunun ekibe yaydığı olaylarla sayaçları ve listeleri tazeler. Kenar
 * çubuğu rozetleri ve "yanıt bekliyor" sayacı, 1-2 dakikalık yenileme
 * aralığını beklemeden yeni soru, fotoğraf ve randevuyu gösterir.
 */
export function useLiveStaffUpdates(): void {
  const invalidate = useInvalidate();
  useSocketEvent(SOCKET_EVENTS.QUESTION_QUEUE_UPDATED, () =>
    invalidate([[...qk.dashboard], ['questions']]),
  );
  useSocketEvent('photo:new', () => invalidate([[...qk.dashboard], ['photos']]));
  useSocketEvent('appointment:updated', () =>
    invalidate([[...qk.dashboard], ['appointments']]),
  );
}
